import React, {useEffect, useState} from 'react';
import Popup from '../../shared/popup';
import Button from '../button';
import Input from "../../shared/inputs/input";

const ConfirmationPopup: React.FC<{
  title?: string;
  message?: string;
  positiveCallback: () => void;
  positiveButtonText?: string;
  negativeCallback?: () => void;
  negativeButtonText?: string;
  showButton?: boolean;
  requireMath?: boolean;
}> = ({
  title = "",
  message = "",
  positiveCallback,
  positiveButtonText = "",
  negativeCallback,
  negativeButtonText = "",
  showButton = true,
  requireMath = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [math, setMath] = useState( [ Math.floor(Math.random() * 8) + 1, Math.floor(Math.random() * 8) + 1 ])
  const [mathResponse, setMathResponse] = useState(0)
  const [showIncorrectMath, setShowIncorrectMath] = useState(false)

  return (
    <>
      { showButton &&
        <Button large outline onClick={() => setIsOpen(true)}>
          <text> Open Confirmation Popup</text>
        </Button>
      }
      {((showButton && isOpen ) || !showButton ) && (
        <Popup noHeader onClose={() => showButton ? setIsOpen(false) : negativeCallback?.()}>
          <group>
            <group data-space="30" data-direction="column">
              <text
                data-wrap="wrap"
                data-accent=""
                data-text-size="medium"
                data-wrap-line=""
              >
                {title || "Please Confirm"}
              </text>
              <text data-wrap="wrap" data-text-size="medium" data-wrap-line="">
                {message || "Are you sure?"}
              </text>
            </group>
            { requireMath && 
              <group data-space="30" data-direction="column">
                <Input
                  name="mathResponse"
                  label={ "Add  to confirm: " + math[0] + " + " + math[1] + " = " }
                  size="large"
                  onChange={(e) => setMathResponse(parseInt(e.target?.value)) }
                />
                { showIncorrectMath && 
                  <text
                    data-wrap="wrap"
                    data-accent=""
                    data-text-size="medium"
                    data-wrap-line=""
                    data-color="red"
                    data-weight="700"
                  >
                    Incorrect Answer, Try Again
                  </text>
                }
              </group>
            }
            <group
              data-space="30"
              data-gap="10"
              data-background="highlight"
              data-type="grid"
            >
              <button
                type="button"
                effect="material"
                className="button primary large"
                onClick={() => {
                  if( (!requireMath) || mathResponse == math[0] + math[1] ) { 
                    positiveCallback?.();
                    setIsOpen(false);
                  } else {
                    setShowIncorrectMath(true)
                  }
                }}
              >
                <text>{positiveButtonText || "Yes"}</text>
              </button>
              <button
                type="button"
                effect="material"
                className="button outline large"
                onClick={() => {
                  negativeCallback?.();
                  setIsOpen(false);
                }}
              >
                <text>{negativeButtonText || "No"}</text>
              </button>
            </group>
          </group>
        </Popup>
      )}
    </>
  );
};
export default ConfirmationPopup;
